export default "__VITE_ASSET__De4Xhns9__"